import { useEffect } from "react";

import { Header } from "../components/header";
import { About } from "../components/about";
import { Features } from "../components/features";
import { Services } from "../components/services";
import { Gallery } from "../components/gallery";
import { Team } from "../components/team";
import { Contact } from "../components/contact";
import { Testimonials } from "../components/testimonials";

const HomePage = ({ data }) => {

    useEffect(() => {
        const shouldScroll = sessionStorage.getItem("fromGallery") === "true";

        if (shouldScroll) {
            const timeout = setTimeout(() => {
                const el = document.getElementById("gallery");
                if (el) {
                    el.scrollIntoView({ behavior: "auto" });
                }
                sessionStorage.removeItem("fromGallery");
            }, 100);

            return () => clearTimeout(timeout);
        }
    }, []);

    return (
        <>
            <Header data={data.Header} />
            <About data={data.About} />
            <Testimonials/> 
            <Features data={data.Features} />
            <Gallery />
            <Services data={data.Services} />
            <Team data={data.Team} />
            <Contact data={data.Contact} />
        </>
    );
};

export default HomePage;
